import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const referralRegistrationMenuRegistry = {
    core_referralRegistration: {
        label: "Referral Registration",
        link: PAGE_URL.REFERRAL_REGISTRATION_PAGE,
        key: PAGE_URL.REFERRAL_REGISTRATION_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default referralRegistrationMenuRegistry;
